import { render, staticRenderFns } from "./League2depthView.vue?vue&type=template&id=226bcefa&scoped=true&"
import script from "./League2depthView.vue?vue&type=script&lang=js&"
export * from "./League2depthView.vue?vue&type=script&lang=js&"
import style0 from "./League2depthView.vue?vue&type=style&index=0&id=226bcefa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226bcefa",
  null
  
)

export default component.exports